import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectionType, DatatableComponent } from '@swimlane/ngx-datatable';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ToastrService } from 'ngx-toastr';
import { InfoMessage } from 'src/app/shared/all-routes';
import { HttpService } from 'src/app/shared/http.service';

@Component({
  selector: 'app-underwriter-lirma',
  templateUrl: './underwriter-lirma.component.html',
})
export class UnderWriterLirmaComponent {
  SelectionType = SelectionType;
  api: string = 'GetUnderwriterLIRMADataTableRows';
  data: any = {};
  columns = [];
  selectedRow: any = {};
  updatedRows: any[] = [];
  queryParams: any = {};
  rows: any[] = [];
  selected: any = [];
  originalData: any[] = [];
  tempRows: any[] = [];
  count: any;
  currentVisible: number = 5;
  appInfo: any = {};
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(DatatableComponent) pbTable: DatatableComponent | any;
  tableOptions: any = {
    HeaderHeight: '50',
    FooterHeight: '50',
    Limit: '4',
    ColumnMode: 'force',
    RowHeight: 'auto',
  };
  searchAll: string = '';
  searchName: string = '';
  searchCountry: string = '';
  constructor(private httpService: HttpService,
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    let that = this;
    that.appInfo = this.httpService.getAppInfo(-9985);
    that.queryParams = that.route.snapshot.queryParams;
    that.get();
  }
  //api functions

  get() {
  let that = this;
  that.httpService.get(that.api).subscribe((res: any) => {
    const sortedRows = (res.Rows || []).sort((a: any, b: any) =>
      (a.UnderwriterName || '').localeCompare(b.UnderwriterName || '')
    );

    that.rows = sortedRows;
    that.tempRows = sortedRows;
  });
}

  copy(records: any[]) {
    let result: any = [];
    for (var i = 0, len = records.length; i < len; i++) {
      result[i] = {}; // empty object to hold properties added below
      for (var prop in records[i]) {
        result[i][prop] = records[i][prop]; // copy properties from arObj to ar2
      }
    }
    return result;
  }
 
  applyFilter() {
    let that = this;

    const allVal = (that.searchAll || '').toLowerCase();
    const nameVal = (that.searchName || '').toLowerCase();
    const countryVal = (that.searchCountry || '').toLowerCase();

    that.rows = that.tempRows.filter((row: any) => {

      const matchesAll = !allVal || [
        'MarketType',
        'UnderwriterName',
        'UnderwriterKnownAs',
        'Pseudonym',
        'Syndicate',
        'BureauCode',
        'Country'
      ].some(field =>
        row[field]?.toString().toLowerCase().includes(allVal)
      );

      const matchesName = !nameVal ||
        row.UnderwriterName?.toLowerCase().includes(nameVal);

      const matchesCountry = !countryVal ||
        row.Country?.toLowerCase().includes(countryVal);

      return matchesAll && matchesName && matchesCountry;
    });

    that.rows = [...that.rows];
    that.pbTable.offset = 0;
  }

  getRowClass(row: any): string {
    if (row.isSelected) {
      return 'row-color';
    } else {
      return '';
    }
  }
  onRowActivate(event: any) {
    if (event.type === 'click') {
      this.selectRow(event.row);
    }
  }
  checkboxRowSelect(rowData: any) {
    if (rowData.isSelected) {
      this.selectRow(rowData);
    } else {
      this.rows.forEach((data: any) => data.isSelected = false);
      this.selectedRow = null;
      this.rows = [...this.rows];
    }
  }
  selectRow(rowData: any) {
    const isAlreadySelected = this.selectedRow?.UnderwriterId === rowData.UnderwriterId;

    if (isAlreadySelected) {
      this.rows.forEach((data: any) => {
        data.isSelected = false;
      });
      this.selectedRow = null;
    } else {
      this.rows.forEach((data: any) => {
        data.isSelected = data.UnderwriterId === rowData.UnderwriterId;
      });
      this.selectedRow = rowData;
    }

    this.rows = [...this.rows];
  }
  select() {
    let that = this;
    let selectedData = that.selectedRow;
    selectedData.UnderwriterId ? that.activeModal.close(selectedData) : that.toastr.warning(InfoMessage.SelectMessage, "Warning!");
  }

  close() {
    let that = this;
    that.activeModal.close();
  }

}
